export default "__VITE_ASSET__70IUgKya__"